module.exports = __webpack_public_path__ + "images/anon.png?v=cf0c0e9b82a1195935e9bd416007cbd7";